"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const GET_PROMO_CODE = (0, client_1.gql) `
  query eventTickets($eventId: String, $seasonId: String, $promoCode: String!) {
    eventTickets(
      eventId: $eventId
      seasonId: $seasonId
      promoCode: $promoCode
    ) {
      promoType
      eventTickets {
        _id
        name
        description
        totalQty
        remainingQty
        performanceIds
        tiers {
          _id
          name
          price
          startsAt
          endsAt
          totalQty
          remainingQty
        }
        purchaseLimit
        visible
        values
        dayIds
      }
      eventUpgrades {
        _id
        name
        price
        totalQty
        remainingQty
        purchaseLimit
        complimentary
        complimentaryWith
        complimentaryQty
        ticketTypeIds
        imageUrl
        description
        rollFees
        visible
      }
      active
      startsAt
      endsAt
      remainingQty
      overRideMax
      overRideMaxUpg
    }
  }
`;
exports.default = GET_PROMO_CODE;
//# sourceMappingURL=promoCodeVerify.query.js.map